<template>
  <nav class="nav" :class="{ 'is-home-blue': $route.path === '/' }" aria-label="底部导航">
    <button type="button" class="nav-item" :class="{ active: type === 0 }" @click="onChange(0)">
      <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 10.7 12 3l9 7.7v9.1A1.2 1.2 0 0 1 19.8 21H15v-6H9v6H4.2A1.2 1.2 0 0 1 3 19.8v-9.1Z" />
      </svg>
      <span>{{ $t('Home') }}</span>
    </button>

    <button type="button" class="nav-item" :class="{ active: type === 1 }" @click="onChange(1)">
      <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 10h8V7.8H8.8A3.3 3.3 0 1 1 12 3.5 3.3 3.3 0 1 1 15.2 7.8H13V10h8a1 1 0 0 1 1 1v3h-9v8h-2v-8H2v-3a1 1 0 0 1 1-1Zm6-4.2h2V5.5A1.5 1.5 0 1 0 9 6.9V5.8Zm6 0v1.1a1.5 1.5 0 1 0-2-1.4v.3h2ZM3 15h8v7H4a1 1 0 0 1-1-1v-6Zm10 0h8v6a1 1 0 0 1-1 1h-7v-7Z" />
      </svg>
      <span>{{ $t('Promotions') }}</span>
    </button>

    <button type="button" class="nav-item" :class="{ active: type === 2 }" @click="onChange(2)">
      <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M9 3h6l-1.3 3H16a2 2 0 0 1 1.8 1.1l3 6A5.4 5.4 0 0 1 16.9 21H7.1a5.4 5.4 0 0 1-3.9-7.9l3-6A2 2 0 0 1 8 6h2.3L9 3Z" />
        <path class="nav-icon-line" d="M9 11.2h6M12 10v7M9.2 14.1h5.6" />
      </svg>
      <span>{{ $t('Deposit') }}</span>
    </button>

    <button type="button" class="nav-item" :class="{ active: type === 3 }" @click="onChange(3)">
      <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
        <circle class="nav-icon-ring" cx="12" cy="12" r="9" />
        <path class="nav-icon-line" d="M8.5 8.5h7M12 7v10M8.8 12h6.4M8.5 15.5h7" />
      </svg>
      <span>{{ $t('Earn') }}</span>
    </button>

    <button type="button" class="nav-item" :class="{ active: type === 4 }" @click="onChange(4)">
      <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="7.5" r="4.2" />
        <path d="M4 21a8 8 0 0 1 16 0H4Z" />
      </svg>
      <span>{{ $t('Mine') }}</span>
    </button>
  </nav>
</template>

<script>
export default {
  name: 'Foot',
  data() {
    return { type: 0 };
  },
  methods: {
    isLoggedIn() {
      return !!(this.$store.state.token || sessionStorage.getItem('token'));
    },
    emitHomeRealnamePrompt() {
      const requestId = `home-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      window.dispatchEvent(new CustomEvent('cs-home-realname-prompt', {
        detail: { requestId }
      }));
    },
    onChange(type) {
      this.type = type;

      if (type === 0) {
        if (this.$route.path === '/') {
          if (this.isLoggedIn()) {
            this.emitHomeRealnamePrompt();
          }
          return;
        }
        this.$router.push('/');
      }
      if (type === 1) {
        this.$router.push('/activity');
      }
      if (type === 2) {
        this.$router.push('/recharge');
      }
      if (type === 3) {
        this.$router.push('/shareMoney');
      }
      if (type === 4) {
        this.$router.push('/mine');
      }
    },
    changPath() {
      const path = this.$route.path;
      if (path === '/') {
        this.type = 0;
      }
      if (path === '/activity') {
        this.type = 1;
      }
      if (path === '/recharge') {
        this.type = 2;
      }
      if (path === '/shareMoney' || path === '/makeMoney') {
        this.type = 3;
      }
      if (path === '/mine') {
        this.type = 4;
      }
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.changPath();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 68px;
  padding-bottom: env(safe-area-inset-bottom);
  border-top: 1px solid #eadfd2;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 -7px 22px rgba(104, 69, 36, 0.08);
  backdrop-filter: blur(12px);
  box-sizing: border-box;
}

.nav-item {
  position: relative;
  display: flex;
  flex: 1;
  height: 100%;
  padding: 6px 0 4px;
  border: 0;
  background: transparent;
  color: #a39a92;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;

  span {
    margin-top: 3px;
    color: currentColor;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.15;
    white-space: nowrap;
  }

  &.active {
    color: #9a5a27;

    .nav-icon {
      transform: translateY(-1px) scale(1.04);
      filter: drop-shadow(0 3px 4px rgba(154, 90, 39, 0.18));
    }
  }
}

.nav-icon {
  width: 28px;
  height: 28px;
  fill: currentColor;
  transition: color 0.18s ease, transform 0.18s ease;
}

.nav-icon-line,
.nav-icon-ring {
  fill: none;
  stroke: #fff;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.nav-icon-ring {
  stroke: currentColor;
  stroke-width: 2.4;
}

.nav-item:nth-child(4) .nav-icon-line {
  stroke: currentColor;
  stroke-width: 1.8;
}

.nav.is-home-blue {
  border-top-color: rgba(150, 196, 255, 0.18);
  background: linear-gradient(180deg, #0b3fa8 0%, #1258d0 100%);
  box-shadow: 0 -8px 22px rgba(2, 12, 40, 0.28);
  color: #d7e6ff;

  .nav-item {
    color: #d7e6ff;

    &.active {
      color: #ffffff;

      .nav-icon {
        filter: drop-shadow(0 3px 4px rgba(0, 0, 0, 0.22));
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue